import BeingPart from '../components/screens/amigas/beingpart/BeingPart'
import Whydoit from '../components/screens/amigas/whydoit/Whydoit'
import NewsletterCTA from '../components/NewsletterCTA'

const Friends = () => {
    return (
        <>
          <BeingPart /> 
          <Whydoit />
          <NewsletterCTA />
        </>
    )
}

export default Friends
